import { RootState } from 'store'

export const selectLoadingState = (state: RootState) => state.contact.isLoading
export const selectSuccessState = (state: RootState) => state.contact.isSuccess
